import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { required } from '@ds/components/Form'

import translations from '../components/UserInformation/InputAddressNationality/InputAddressNationality.translations'

export const InputAddressNationalityValidators = (
  i18n: ReturnType<typeof useI18n>,
) => ({
  required: required(i18n(translations.required)),
})
